import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  api,
  callApiSignin,
  callApiSignup,
  callApiResetPassword,
  callApiUpdatePassword,
  callApiWhiteLabelSignup,
  callApiWhiteLabelSignin,
  callApiFetchBusinessUsers,
  callApiBusinessSignup,
} from "../../services/index";

import { setStorageItem, removeAllStorage } from "../../helpers/";
import {
  WHITE_LABEL_SIGNUP_SUCCESS,
  WHITE_LABEL_SIGNUP_FAILURE,
} from "../types";

export const onClickSignin = (data) => {
  return async (dispatch) => {
    // console.log("data 123", data);
    return callApiSignin(data).then(async (res) => {
      console.log("res", res);

      if (res.success === true) {
        // console.log("...................", data.subdomain);
        // return callApiFetchBusinessUsers(data.subdomain).then(async (res) => {
        // console.log("res", res);
        removeAllStorage();

        if (res.data.isAdmin) {
          // Encrypt
          var ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify(res.data),
            "userData"
          ).toString();

          // console.log("ciphertext", ciphertext);
          setStorageItem("accessToken", res.data.accessToken);
          setStorageItem("userData", ciphertext);
          data.history.push("/control-panel");
        } else {
          data.history.push("/subdomain");
        }

        /* else {
          const businessDetails =
            res.data &&
            res.data.businessDetails &&
            res.data.businessDetails.length > 0 &&
            res.data.businessDetails.filter((v, i) => {
              return v.primaryUser === true && v.userType === "admin" && v;
            });

          //console.log("businessDetails", businessDetails);

          if (
            businessDetails !== null &&
            businessDetails &&
            businessDetails.length > 0
          ) {
            data.history.push("/control-panel");
          } else {
            data.history.push("/dashboard");
          }
        } */

        // data.history.push("/choose-business");

        // });
      } else {
        toast.error(res.errors, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    });
  };
};

export const onClickSignup = (data) => {
  return async (dispatch) => {
    /* console.log("====================================");
    console.log("data", data);
    console.log("===================================="); */

    return callApiSignup(data).then(async (res) => {
      if (res.success === true) {
        // console.log("res", res);
        removeAllStorage();

        // Encrypt
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify(res.data),
          "userData"
        ).toString();

        // console.log("ciphertext", ciphertext);
        setStorageItem("accessToken", res.data.accessToken);
        setStorageItem("userData", ciphertext);

        /* const encUserData = cryptr.encrypt(JSON.stringify(res.data));
        setStorageItem("accessToken", res.data.accessToken);
        setStorageItem("userData", encUserData); */

        toast.error("You are signup succesfully.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });

        data.history.push("/dashboard");
      } else {
        toast.error(res.errors, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    });
  };
};

export const onClickBusinessSignup = (data) => {
  return async (dispatch) => {
    /* console.log("====================================");
    console.log("data", data);
    console.log("===================================="); */

    return callApiBusinessSignup(data).then(async (res) => {
      if (res.success === true) {
        // console.log("res", res);

        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      } else {
        // console.log("ERROR");
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }

      return res.success;
    });
  };
};

export const onClickWhiteLabelSignup = (data) => {
  return async (dispatch) => {
    /* console.log("====================================");
    console.log("data", data);
    console.log("===================================="); */

    return callApiWhiteLabelSignup(data).then(async (res) => {
      if (res.success === true) {
        // console.log("res", res);

        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      } else {
        toast.error(res.message || res.errors, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    });
  };
};

export const onClickWhiteLabelSignin = (data) => {
  return async (dispatch) => {
    // console.log("onClickWhiteLabelSignin", data);
    return callApiWhiteLabelSignin(data).then(async (res) => {
      if (res.success === true) {
        removeAllStorage();

        const hostname = window.location.hostname;
        const parts = hostname.split(".");
        const subdomain = parts[0];

        console.log("onClickWhiteLabelSignin subdomain", subdomain);

        if (res.data.subdomain && res.data.subdomain === subdomain) {
          // Encrypt
          var ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify(res.data),
            "userData"
          ).toString();

          // console.log("ciphertext", ciphertext);
          setStorageItem("accessToken", res.data.accessToken);
          setStorageItem("userData", ciphertext);

          // console.log("res.data", res.data.businessDetails);

          if (
            res.data &&
            res.data.businessDetails &&
            res.data.businessDetails.length > 0
          ) {
            if (res.data.businessDetails[0].userType === "admin") {
              window.location.href = "/control-panel";
            } else {
              window.location.href = "/dashboard";
            }
          }
        } else {
          window.location.href = "/subdomain";
        }

        /* if (res.data.userType === "white-label-admin") {
          console.log("white label admin");
          // window.location.href = "/create/saq-d-sp";
          window.location.href = "/white-label/control-panel";
        } else {
          // window.location.href = "/dashboard";

          console.log("user dashboard");
        } */
      } else {
        toast.error(res.errors, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    });
  };
};

export const onLoadVerifyTg30User = (data) => {
  return async (dispatch) => {
    // console.log("data 123", data);

    const { queries } = data;

    let success = false;

    if (queries.accessToken) {
      removeAllStorage();

      // console.log("queries", queries);

      const verifiedUser = await api.service("api/signin").find({
        query: {
          userId: queries.userId,
          email: queries.email,
          accessToken: queries.accessToken,
        },
      });

      /* console.log("verifiedUser", verifiedUser);
      console.log("verifiedUser", verifiedUser.data && verifiedUser.data);
      console.log(
        "verifiedUser typeof",
        typeof verifiedUser.data.appAccessToken
      ); */

      if (
        verifiedUser.success &&
        verifiedUser.data &&
        verifiedUser.data.appAccessToken !== "" &&
        verifiedUser.data.appAccessToken === queries.accessToken
      ) {
        // console.log("ACCESS TOKEN MATCHED ==========");

        // Encrypt
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify({ userId: queries.userId, email: queries.email }),
          "userData"
        ).toString();

        // console.log("ciphertext", ciphertext);
        setStorageItem("accessToken", queries.accessToken);
        setStorageItem("userData", ciphertext);

        /* const encUserData = cryptr.encrypt(
          JSON.stringify({ userId: queries.userId, email: queries.email })
        );
        setStorageItem("accessToken", queries.accessToken);
        setStorageItem("userData", encUserData); */

        // console.log("verifiedUser", verifiedUser);

        success = true;

        // console.log("success", success);
      } else {
        // console.log("ACCESS TOKEN NOT MATCHED");
      }
    }

    // console.log("success", success);

    if (success === true) {
      // console.log("SUCCESS - TRUE");
      data.history.push("/dashboard");
      // data.history.push("/choose-business");
    } else {
      data.history.push("/signin");
      // console.log("SUCCESS - FALSE");
    }
  };
};

export const onClickResetPassword = (data) => {
  return async (dispatch) => {
    //console.log("data", data);
    return callApiResetPassword(data).then((res) => {
      if (res.success) {
        /* dispatch({
          type: RESET_PASSWORD_SUCCESS,
          payload: res,
        }); */
        // console.log("res", res);
        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      } else {
        /* dispatch({
          type: RESET_PASSWORD_FAILURE,
        }); */

        if (res.code === 200) {
          toast.error(res.errors, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        } else {
          toast.success(res.errors, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        }
      }
    });
  };
};

export const onClickUpdatePassword = (data) => {
  return async (dispatch) => {
    return callApiUpdatePassword(data).then((res) => {
      if (res.success) {
        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      } else {
        if (res.code === 200) {
          toast.error(res.errors, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        } else {
          toast.success(res.errors, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        }
      }
    });
  };
};
